"use client";

export { Separator } from "@repo/ui/separator";
